<template>
    <div class="information-content">
      <div>
        <el-row>
          <el-col :span="3">
            <el-select v-model="form.crew" placeholder="会议室场景" size="mini">
              <el-option label="会议室场景" value="会议室场景"></el-option>
              <el-option label="办公室场景" value="办公室场景"></el-option>
              <el-option label="宿舍/公寓场景" value="宿舍/公寓场景"></el-option>
              <el-option label="地下停车场场景" value="地下停车场场景"></el-option>
              <el-option label="酒店客房场景" value="酒店客房场景"></el-option>
              <el-option label="教室场景" value="教室场景"></el-option>
              <el-option label="餐厅场景" value="餐厅场景"></el-option>
              <el-option label="手术室场景" value="手术室场景"></el-option>
              <el-option label="机房场景" value="机房场景"></el-option>
            </el-select>
          </el-col>
          <el-col :span="20">
            <el-form ref="form" :model="form" label-width="100px" size="mini" >
              <el-row>
                <el-col :span="4">
                  <el-form-item label="数量" class="item">
                    <el-input v-model="numb"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="备注" class="item">
                    <el-input v-model="remarks"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
          <el-col :span="1">
            <div style="width: 30px;height: 30px;background-image: url('/static/img/new-icno/购物车.png');background-size: 100% 100%;cursor: pointer;margin-left: 8px"></div>
          </el-col>
        </el-row>
      </div>
      <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 100%;margin-top: 10px">
        <el-row>
          <el-col :span="2">
             <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                    placement="bottom"
                    title=""
                    width="50"
                    trigger="click"
                  >
                    <el-checkbox-group v-model="fan" @change="fanSelect">
                      <el-checkbox label="暖气" name="暖气"></el-checkbox>
                      <el-checkbox label="VRV" name="VRV" ></el-checkbox>
                      <el-checkbox label="风机盘管" name="风机盘管" ></el-checkbox>
                    </el-checkbox-group>
                    <el-button slot="reference"  size="mini">空调形式</el-button>
                  </el-popover>
                  </div>
                </el-col>
              </el-row>
          </el-col>
          <el-col :span="18">
            <el-form ref="form" :model="form" label-width="100px" size="mini" style="margin-left: -6%;">
              <!--VRV-->
              <el-row >
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="VRV" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="品牌" class="item">
                      <el-input v-model="fanArray.returnpower">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="型号" class="item">
                      <el-input v-model="fanArray.returnpower">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="功率" class="item">
                      <el-input v-model="fanArray.returnpower">
                        <template slot="append">kwh</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="fanArray.returnpower">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="控制方式" class="item">
                      <el-select v-model="tipData" placeholder="请选择">
                        <el-option
                          v-for="item in tipArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <!--暖气-->
              <el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="暖气" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="阀门" class="item">
                      <el-select v-model="tipData" placeholder="请选择">
                        <el-option
                          v-for="item in tipArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="控制形式" class="item">
                      <el-select v-model="tipData" placeholder="请选择">
                        <el-option
                          v-for="item in tipArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="fanArray.givepressure">
                        <div><template slot="append">m³/h</template></div>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <!--风机盘管-->
              <el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="风机盘管" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="阀门" class="item">
                      <el-select v-model="tipData" placeholder="请选择">
                        <el-option
                          v-for="item in tipArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="控制形式" class="item">
                      <el-select v-model="tipData" placeholder="请选择">
                        <el-option
                          v-for="item in tipArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="fanArray.givepressure">
                        <div><template slot="append">m³/h</template></div>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <!--<div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 100%;margin-top: 10px">
        <el-row>
          <el-col :span="2">
            <el-row>
              <el-col :span="24">
                <div>
                  <el-popover
                    placement="bottom"
                    title=""
                    width="50"
                    trigger="click"
                  >
                    <el-checkbox-group v-model="heatTransfer"  @change="heatTran">
                      <el-checkbox label="表冷段" name="表冷段" disabled></el-checkbox>
                      <el-checkbox label="电加热段" name="电加热段"></el-checkbox>
                      <el-checkbox label="蒸汽盘管段" name="蒸汽盘管段"></el-checkbox>
                      <el-checkbox label="热水盘管段" name="热水盘管段"></el-checkbox>
                    </el-checkbox-group>
                    <el-button slot="reference"  size="mini">暖气</el-button>
                  </el-popover>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="19">
            <el-form ref="form" :model="form" label-width="100px" size="mini" style="margin-left: -6%">
              &lt;!&ndash;表冷段&ndash;&gt;
              <el-row v-if="surfaceCool">
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="暖气" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="阀门" class="item">
                      <el-input v-model="z">
                        <template slot="append">kw</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="管径" class="item">
                      <el-input v-model="x">
                        <template slot="append">m³/h</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="c">
                        <template slot="append">kPa</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              &lt;!&ndash;热水盘管段&ndash;&gt;
              <el-row v-if="hotWater">
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="热水盘管" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="制冷(热)量" class="item">
                      <el-input v-model="v">
                        <template slot="append">W</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="水流量" class="item">
                      <el-input v-model="b">
                        <template slot="append">m³/h</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="水压降" class="item">
                      <el-input v-model="n">
                        <template slot="append">kPa</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              &lt;!&ndash;电加热段&ndash;&gt;
              <el-row v-if="electricHeat">
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="电加热段" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="电功率" class="item">
                      <el-input v-model="m">
                        <template slot="append">kwh</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="分组数量" class="item">
                      <el-input v-model="a">
                        <template slot="append">m³/h</template>
                      </el-input>
                    </el-form-item>
                  </el-col>

                </el-col>
              </el-row>
              &lt;!&ndash;蒸汽盘管段&ndash;&gt;
              <el-row v-if="steamCoil">
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="蒸汽盘管" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="蒸汽压力" class="item">
                      <el-input v-model="s">
                        <template slot="append">Mpa</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="蒸汽流量" class="item">
                      <el-input v-model="d">
                        <template slot="append">m³/h</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="" class="item">
                      <el-checkbox v-model="checked">执行器弹簧复位</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>-->
      <!-- <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 100%;margin-top: 10px">
        <el-row>
          <el-col :span="2">
            <el-row>
              <el-col :span="24">
                <div>
                  <el-popover
                    placement="bottom"
                    title=""
                    width="50"
                    trigger="click"
                  >
                    &lt;!&ndash;<el-checkbox-group v-model="humidification" >
                      <el-checkbox label="表冷段" name="表冷段"></el-checkbox>
                      <el-checkbox label="电加热段" name="电加热段"></el-checkbox>
                      <el-checkbox label="蒸汽盘管段" name="蒸汽盘管段"></el-checkbox>
                      <el-checkbox label="热水盘管段" name="热水盘管段"></el-checkbox>
                    </el-checkbox-group>&ndash;&gt;
                    <el-radio-group v-model="humidification"  @change="humidificationSelect">
                      <el-radio :label="0">无</el-radio>
                      <el-radio :label="3">蒸汽加湿</el-radio>
                      <el-radio :label="6">湿膜加湿</el-radio>
                      <el-radio :label="9">高压喷雾加湿</el-radio>
                    </el-radio-group>
                    <el-button slot="reference"  size="mini">VRV</el-button>
                  </el-popover>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="19">
            <el-form ref="form" :model="form" label-width="100px" size="mini" style="margin-left: -6%">
              &lt;!&ndash;蒸汽加湿&ndash;&gt;
              <el-row v-if="steamShow">
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="vrv" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item label="品牌" class="item">
                      <el-input v-model="f">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="型号" class="item">
                      <el-input v-model="g">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="功率" class="item">
                      <el-input v-model="g">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="电机功率" class="item">
                      <el-input v-model="g">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="g">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              &lt;!&ndash;湿膜加湿&ndash;&gt;
              <el-row v-if="membraneShow">
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="湿膜加湿" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="控制方式" class="item">
                      <el-select v-model="humidiData" placeholder="请选择">
                        <el-option
                          v-for="item in humidiArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                &lt;!&ndash;  <el-col :span="5">
                    <el-form-item label="管径">
                      <el-input v-model="form.name">
                        <template slot="append">m³</template>
                      </el-input>
                    </el-form-item>
                  </el-col>&ndash;&gt;
                </el-col>
              </el-row>
              &lt;!&ndash;高压喷雾加湿&ndash;&gt;
              <el-row v-if="highpressureShow">
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="高压喷雾加湿" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="控制方式" class="item">
                      <el-select v-model="humidiData" placeholder="请选择">
                        <el-option
                          v-for="item in humidiArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  &lt;!&ndash;<el-col :span="5">
                    <el-form-item label="管径">
                      <el-input v-model="form.name">
                        <template slot="append">m³</template>
                      </el-input>
                    </el-form-item>
                  </el-col>&ndash;&gt;
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>-->
      <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 100%;margin-top: 10px">
        <el-row>
          <el-col :span="2">
            <el-row>
              <el-col :span="24">
                <div class="tool">
                  <el-popover
                    placement="bottom"
                    title=""
                    width="50"
                    trigger="click"
                  >
                    <el-checkbox-group v-model="guolv" @change="filterSelect">
                      <el-checkbox label="新风口" name="新风口"></el-checkbox>
                      <el-checkbox label="窗控" name="窗控"></el-checkbox>
                    </el-checkbox-group>
                    <el-button slot="reference"  size="mini">换气方式</el-button>
                  </el-popover>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="19">
            <el-form ref="form" :model="form" label-width="100px" size="mini" style="margin-left: -6%">
              <!--回风段-->
              <el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" v-if="iniFilter">
                    <el-form-item label="新风孔" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="iniFilter">
                    <el-form-item label="孔径大小" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" v-if="mediumFilter">
                    <el-form-item label="中效滤段" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="mediumFilter">
                    <el-form-item label="压差" class="item">
                      <el-input v-model="j">
                        <template slot="append">Pa</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" v-if="effcientFilter">
                    <el-form-item label="高效滤段" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="effcientFilter">
                    <el-form-item label="压差" class="item">
                      <el-input v-model="k">
                        <template slot="append">Pa</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" v-if="iniFilter">
                    <el-form-item label="窗口" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="iniFilter">
                    <el-form-item label="孔径大小" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" v-if="mediumFilter">
                    <el-form-item label="中效滤段" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="mediumFilter">
                    <el-form-item label="压差" class="item">
                      <el-input v-model="j">
                        <template slot="append">Pa</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" v-if="effcientFilter">
                    <el-form-item label="高效滤段" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="effcientFilter">
                    <el-form-item label="压差" class="item">
                      <el-input v-model="k">
                        <template slot="append">Pa</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 100%;margin-top: 10px">
        <el-row>
          <el-col :span="2">
            <el-row>
              <el-col :span="24">
                <div class="tool">
                  <el-popover
                    placement="bottom"
                    title=""
                    width="50"
                    trigger="click"
                  >
                    <el-checkbox-group v-model="guolv" @change="filterSelect">
                      <el-checkbox label="滑轨门" name="滑轨门"></el-checkbox>
                      <el-checkbox label="合页门" name="合页门"></el-checkbox>
                      <el-checkbox label="玻璃门" name="玻璃门"></el-checkbox>
                      <el-checkbox label="平口门" name="平口门"></el-checkbox>
                      <el-checkbox label="T型门口" name="T型门口"></el-checkbox>
                      <el-checkbox label="板式门" name="板式门"></el-checkbox>
                    </el-checkbox-group>
                    <el-button slot="reference"  size="mini">门形式</el-button>
                  </el-popover>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="19">
            <el-form ref="form" :model="form" label-width="100px" size="mini" style="margin-left: -6%">
              <!--门1-->
              <!--<el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="滑轨门" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-form-item label="合页门" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="j">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-form-item label="玻璃门" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="k">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-form-item label="平口门" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="k">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>-->
              <!--门2-->
              <el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="T型门口" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-form-item label="板式门" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="数量" class="item">
                      <el-input v-model="j">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 100%;margin-top: 10px">
        <el-row>
          <el-col :span="2">
            <el-row>
              <el-col :span="24">
                <div class="tool">
                  <el-popover
                    placement="bottom"
                    title=""
                    width="50"
                    trigger="click"
                  >
                    <el-checkbox-group v-model="guolv" @change="filterSelect">
                      <el-checkbox label="开关控制" name="开关控制"></el-checkbox>
                      <el-checkbox label="调光控制" name="调光控制"></el-checkbox>
                    </el-checkbox-group>
                    <el-button slot="reference"  size="mini">照明</el-button>
                  </el-popover>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="19">
            <el-form ref="form" :model="form" label-width="100px" size="mini" style="margin-left: -6%">
              <!--开关控制-->
              <el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" v-if="iniFilter">
                    <el-form-item label="开关控制" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="iniFilter">
                    <el-form-item label="回路数量" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <!--调光控制-->
              <el-row>
                <el-col :span="24">
                  <el-col :span="1">
                    <el-form-item label="">
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" v-if="iniFilter">
                    <el-form-item label="调光控制" class="item">
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="iniFilter">
                    <el-form-item label="回路数量" class="item">
                      <el-input v-model="h">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 99%;height: 42%">
        <span>控制组件配置清单</span>
       <el-row :gutter="50" type="flex"  style="min-height: 100%;">
         <el-col :span="15">
           <div style="width: 100%;height: 100%;overflow: hidden">
             <el-table
               :data="tableData"
               border
               style="width: 100%">
               <el-table-column
                 prop="xuhao"
                 label="序号"
                 width="50">
               </el-table-column>
               <el-table-column
                 prop="name"
                 label="设备名称"
                 width="180">
               </el-table-column>
               <el-table-column
                 prop="model"
                 label="产品型号"
                 width="180">
               </el-table-column>
               <el-table-column
                 prop="number"
                 label="数量"
                 width="70">
               </el-table-column>
               <el-table-column
                 prop="parameter"
                 label="主要技术参数">
               </el-table-column>
             </el-table>
           </div>
         </el-col>
         <el-col :span="9">
           <div style="width: 100%;height: 100%;overflow: hidden">
             <el-row>
               <el-col :span="3" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">控制程序:</span>
               </el-col>
               <el-col :span="15">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt"> <el-button size="mini" type="primary" style="margin-left: 5%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数据表&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button></div>
               </el-col>
             </el-row>
             <el-row style="margin-top: 4%">
               <el-col :span="3" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">接线图:</span>
               </el-col>
               <el-col :span="15">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt"> <el-button size="mini" type="primary" style="margin-left: 5%">&nbsp;&nbsp;&nbsp;&nbsp;标准图库&nbsp;&nbsp;&nbsp;</el-button></div>
               </el-col>
             </el-row>
             <el-row style="margin-top: 4%">
               <el-col :span="3" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">控制原理图:</span>
               </el-col>
               <el-col :span="15">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt"> <el-button size="mini" type="primary" style="margin-left: 5%">控制方案说明</el-button></div>
               </el-col>
             </el-row>
             <el-row style="margin-top: 4%">
               <el-col :span="5" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">设备监控界面模板:</span>
               </el-col>
               <el-col :span="13">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt">  <el-button size="mini" type="primary" style="margin-left: 5%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;模板库&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button></div>
               </el-col>
             </el-row>
           </div>
         </el-col>
       </el-row>
      </div>
    </div>
</template>
<script>
import authorityService from '../../service/authorityService'
export default {
  name: '',
  components: {
    collapse: false
  },
  data () {
    return {
      model:'',// 型号
      brand:'',// 品牌
      numb:'',// 数量
      remarks:'', // 备注
      fanArray:{
        givepower:'',
        givevolume:'',
        givepressure:'',
        returnpower:'',
        returnvolume:'',
        returnpressure:'',
      }, // 风机组
      heatData:{
        coolpower:'',
        coolflow:'',
        coolpress:'',
        electricpower:'',
        electricnum:'',
        steampressure:'',
        steamflow:'',
        hotwaterrefrigeration:'',
        hotwaterflow:'',
        hotwaterhydraulic:'',
      },
      name:'',
      form: {
        name: '',
        region: '卧式',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        crew:'会议室场景控制'
      },
      fan: ["送风机"],
      heatTransfer:["表冷段"],
      humidification:3,
      guolv:['初效过滤段'],
      fengfa:[],
      returnAirShow:false, // 回风展示
      airSupply:true,// 送风展示
      surfaceCool:true, // 表冷段
      electricHeat:false, // 电加热段
      steamCoil:false, // 蒸汽盘管段
      hotWater:false, // 热水盘管
      humidiArray: [{
        value: '阀门',
        label: '阀门'
      }, {
        value: '干接点',
        label: '干接点'
      }],
      humidiData: '',
      tipArray:[
        {
          value: '常规',
          label: '常规'
        }, {
          value: '变频',
          label: '变频'
        }
      ],
      kongzhiArray: [{
        value: '模拟量控制',
        label: '模拟量控制'
      }, {
        value: '开关量控制',
        label: '开关量控制'
      }],
      kongData:'',
      tipData:'',
      steamShow:true,
      membraneShow:false,
      highpressureShow:false,
      iniFilter:true, // 初效过滤段显示
      mediumFilter:false, // 中效过滤段显示
      effcientFilter:false, // 高效过滤段显示
      tableData: [],
      checked:false,
      z:"",
      x:"",
      c:"",
      v:"",
      b:"",
      n:"",
      m:"",
      a:"",
      s:"",
      d:"",
      f:"",
      g:"",
      h:"",
      j:"",
      k:"",
      l:"",
      q:"",
      w:"",
      e:"",
      r:"",
      t:"",
      y:"",
      u:"",
      i:"",
      o:"",
      p:"",
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    //
    // 风机段选择
    fanSelect(){
      if(this.fan.length === 0){
        this.returnAirShow = false
        this.airSupply = false
      }
      if(this.fan.length === 2){
        this.returnAirShow = true
        this.airSupply = true
      }else{
        if(this.fan[0] === "回风机"){
          this.returnAirShow = true
          this.airSupply = false
        }if(this.fan[0] === "送风机"){
          this.returnAirShow = false
          this.airSupply = true
        }

      }
    },
    // 换热段选择
    heatTran(){
      this.surfaceCool = true
      if(this.heatTransfer.length === 0){
          this.electricHeat = false
          this.steamCoil = false
          this.hotWater = false
      }
      if(this.heatTransfer.length === 1){
        this.electricHeat = false
        this.steamCoil = false
        this.hotWater = false
      }
      if(this.heatTransfer.length === 2){
        if(this.heatTransfer.indexOf("电加热段") > -1){
          this.electricHeat = true
          this.steamCoil = false
          this.hotWater = false
        }
        if(this.heatTransfer.indexOf("蒸汽盘管段") > -1){
          this.electricHeat = false
          this.steamCoil = true
          this.hotWater = false
        }
        if(this.heatTransfer.indexOf("热水盘管段") > -1){
          this.electricHeat = false
          this.steamCoil = false
          this.hotWater = true
        }
      }
      if(this.heatTransfer.length === 3){
        if(this.heatTransfer.indexOf("电加热段") > -1 && this.heatTransfer.indexOf("蒸汽盘管段") > -1){
          this.electricHeat = true
          this.steamCoil = true
          this.hotWater = false
        }
        if(this.heatTransfer.indexOf("蒸汽盘管段") > -1 && this.heatTransfer.indexOf("热水盘管段") > -1){
          this.electricHeat = false
          this.steamCoil = true
          this.hotWater = true
        }
        if(this.heatTransfer.indexOf("热水盘管段") > -1 && this.heatTransfer.indexOf("电加热段") > -1){
          this.electricHeat = true
          this.steamCoil = false
          this.hotWater = true
        }
      }
      if(this.heatTransfer.length === 4){
          this.electricHeat = true
          this.steamCoil = true
          this.hotWater = true
      }
    },
    // 加湿段选择
    humidificationSelect(){
      if(this.humidification === 0){
        this.steamShow = false
        this.membraneShow = false
        this.highpressureShow = false
      }
     if(this.humidification === 3){
       this.steamShow = true
       this.membraneShow = false
       this.highpressureShow = false
     }
      if(this.humidification === 6){
        this.steamShow = false
        this.membraneShow = true
        this.highpressureShow = false
      }
      if(this.humidification === 9){
        this.steamShow = false
        this.membraneShow = false
        this.highpressureShow = true
      }
    },
    // 过滤段选择
    filterSelect(){
      if(this.guolv.length === 0){
        this.iniFilter = false
        this.mediumFilter = false
        this.effcientFilter = false
      }
      if(this.guolv.length === 1){
        if(this.guolv[0] === "初效过滤段"){
          this.iniFilter = true
          this.mediumFilter = false
          this.effcientFilter = false
        }
        if(this.guolv[0] === "中效过滤段"){
          this.iniFilter = false
          this.mediumFilter = true
          this.effcientFilter = false
        }
        if(this.guolv[0] === "高效过滤段"){
          this.iniFilter = false
          this.mediumFilter = false
          this.effcientFilter = true
        }
      }
      if(this.guolv.length === 3){
        this.iniFilter = true
        this.mediumFilter = true
        this.effcientFilter = true
      }
      if(this.guolv.length === 2){
        if(this.guolv.indexOf("初效过滤段") > -1 && this.guolv.indexOf("中效过滤段") >-1 ){
          this.iniFilter = true
          this.mediumFilter = true
          this.effcientFilter = false
        }
        if(this.guolv.indexOf("初效过滤段") > -1 && this.guolv.indexOf("高效过滤段") >-1 ){
          this.iniFilter = true
          this.mediumFilter = false
          this.effcientFilter = true
        }
        if(this.guolv.indexOf("中效过滤段") > -1 && this.guolv.indexOf("高效过滤段") >-1){
          this.iniFilter = false
          this.mediumFilter = true
          this.effcientFilter = true
        }
      }
    },
    // 生成控制方案
    generate(){
      this.tableData = [{
        xuhao:'1',
        name:'送风机',
        model:'BAC-4KW',
        number:'1',
        parameter:'包含智能仪表、热继、交流接触器、空开、保险等'
      },{
        xuhao:'2',
        name:'回风机',
        model:'BACS-4KW',
        number:'1',
        parameter:'包含变频器、空开、保险等'
      },{
        xuhao:'3',
        name:'湿膜加湿',
        model:'DN=100',
        number:'1',
        parameter:'根据送风湿度与设定湿度的差值控制加湿阀，达到加湿的效果。'
      },{
        xuhao:'4',
        name:'新风阀',
        model:'',
        number:'1',
        parameter:'新风阀与送风机联动；根据回风CO2浓度PID调节新风阀开度，保证室内空气新鲜和舒适。'
      },{
        xuhao:'5',
        name:'回风阀',
        model:'',
        number:'1',
        parameter:'回风阀与新风阀开度互补，保证新风阀开度与回风阀开度的和为100%。'
      },{
        xuhao:'6',
        name:'排风阀',
        model:'',
        number:'1',
        parameter:'排风阀开度与新风阀开度保持一致，'
      }]
    },
  }
}
</script>
<style scoped>
  .toolbt>>>.el-button{
    background-color: #409eff;
    color: white;
  }
  .tool>>>.el-button{
    background-color: #ffffff;
  }
  .desig-main{
    width: 100%;
    height: 100%;
    font-size: 15px;
  }
.information-content{
  width: 100%;
  height: 100%;
}
  .file-content{
    width: 100%;
  }
  .tit-content{
    font-size: 1.5vh;
    font-family: 宋体;
    font-weight: 600;
  }
  .information-content>>> .item .el-form-item__label{
    font-size: 1vh;
  }
  .information-content>>>.el-input-group__append, .el-input-group__prepend{
    padding: 0 7px;
  }
</style>
<style>
  .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #48adff;
  }
  .el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 32px;
  }
  .el-table__body tr,
  .el-table__body td {
    padding: 0;
    height: 27px;
  }
  .el-input__inner {
    height: 26px;
    border-radius: 0px;
    font-size: 1vh;
    color:#606266;
  }
  .el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Toolmain/sceneshow.vue